import { tabToName } from "@utils/utils";
import React from "react";

import { Button, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { useAdminData } from "@providers/AdminDataProvider";
import { VideoSessionTab, useVideoSessionData } from "@providers/VideoSessionProvider";

interface VideoSideBarProps {
  currentTime: number;
  /**
   * Explicit override for the tab list. When provided, the role-based
   * default is ignored — used by inline mounts (e.g. expert chat
   * overlay) that only want a subset of tabs (e.g. `[VideoSessionTab.Activity]`).
   */
  availableTabs?: VideoSessionTab[];
}

export const VideoSideBar: React.FC<VideoSideBarProps> = ({ availableTabs }) => {
  const { selectedTab, setSelectedTab } = useVideoSessionData();
  const { isUserRBT, isUserCaregiver } = useAdminData();

  const videoSideBarNavigationTabs: VideoSessionTab[] = [
    VideoSessionTab.Activity,
    VideoSessionTab.Summary,
    VideoSessionTab.Moments,
    VideoSessionTab.Transcript,
  ];

  const roleDefaultTabs: readonly VideoSessionTab[] =
    isUserRBT || isUserCaregiver ? [VideoSessionTab.Activity] : videoSideBarNavigationTabs;
  const userTabs: readonly VideoSessionTab[] = availableTabs ?? roleDefaultTabs;

  // Hide the strip entirely when only one tab is visible — nothing to
  // switch between.
  if (userTabs.length <= 1) {
    return null;
  }
  return (
    <div
      className={`min-w-full max-w-[calc(100%)] no-scrollbar overflow-x-scroll ${isUserRBT ? "justify-items-center border-b" : ""}  border-gray-200`}
    >
      <TabNavigation
        edgeToEdge
        tabs={userTabs.map((tab) => ({
          current: selectedTab === tab,
          type: "component",
          name: tab,
          Component: (
            <Button
              text={<div className="w-full flex font-normal flex-row justify-center gap-2">{tabToName(tab)}</div>}
              appearance="text"
              className={`hover:text-primary ${selectedTab === tab ? "text-limestone-900" : "text-text-secondary"}`}
              onClick={() => setSelectedTab(tab)}
            />
          ),
        }))}
      />
    </div>
  );
};
